import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading"},[_c(VProgressCircular,{attrs:{"indeterminate":"","color":"#4B0F42","size":"56","width":"5"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }